


















import { defineComponent } from "@vue/composition-api";
import { Tab, Tabs } from "vant";
import AccountSetting from "@/views/settle/account-setting.vue";
import Export from "@/views/settle/export.vue";
import PaymentList from "@/views/settle/payment-list.vue";
import Other from "@/views/settle/other.vue";

export default defineComponent({
  components: {
    [Tabs.name]: Tabs,
    [Tab.name]: Tab,
    AccountSetting,
    Export,
    PaymentList,
    Other
  },
  data: () => ({
    tab: "accountSetting",
    allowFeeInvoice: false
  }),
  computed: {
    showOther(): boolean {
      return this.allowFeeInvoice;
    }
  },
  created() {
    const initTab = this.$router.currentRoute.query.initTab;
    if (initTab) {
      this.tab = initTab;
    }
    this.loadPageInfo();
  },
  methods: {
    loadPageInfo: async function() {
      this.$axios.post("/api/manage/settle/pageInfo").then(res => {
        const data = res.data.data;
        this.allowFeeInvoice = data.allowFeeInvoice;
      });
    }
  }
});
